import { render } from "./RegisterVerifyCompleted.vue?vue&type=template&id=70930036"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/RegisterVerifyCompleted.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70930036"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70930036', __exports__)) {
    api.reload('70930036', __exports__)
  }
  
  module.hot.accept("./RegisterVerifyCompleted.vue?vue&type=template&id=70930036", () => {
    api.rerender('70930036', render)
  })

}


export default __exports__